const MUTATION_TYPE = {
  setMessages: 'setMessages',
  addMessages: 'addMessages',
  setChats: 'setChats',
  setContact: 'setContact',
  setUnreadChats: 'setUnreadChats',
  clearMessages: 'clearMessages',
  setPagesChats: 'setPagesChats',
  setTotalChats: 'setTotalChats',
  setCurrentPageChats: 'setCurrentPageChats',
  setPagesMessages: 'setPagesMessages',
  setTotalMessages: 'setTotalMessages',
  setCurrentPageMessages: 'setCurrentPageMessages'
}

const ACTION_TYPE = {
  fetchMessages: 'fetchMessages',
  fetchChats: 'fetchChats',
  fetchUnreadChats: 'fetchUnreadChats',
  makeMessagesRead: 'makeMessagesRead',
  clearMessages: 'clearMessages',
  changePageChats: 'changePageChats',
  changePageMessages: 'changePageMessages',
  techSupportRequest: 'techSupportRequest'
}

const GETTER_TYPE = {
  getMessages: 'getMessages',
  getChats: 'getChats',
  getContact: 'getContact',
  getUnreadChats: 'getUnreadChats',
  getPagesChats: 'getPagesChats',
  getTotalChats: 'getTotalChats',
  getCurrentPageChats: 'getCurrentPageChats',
  getPagesMessages: 'getPagesMessages',
  getTotalMessages: 'getTotalMessages',
  getCurrentPageMessages: 'getCurrentPageMessages'
}

export {
  MUTATION_TYPE,
  ACTION_TYPE,
  GETTER_TYPE
}
